import React from 'react';
import { Icon } from '../../../shared/utils/icons';
import WorldMap from './WorldMap';

const ActiveFilters = ({ chips, onRemove }) => {
    if (!chips.length) return null;
    return (
        <div className="active-filters">
            {chips.map((c, i) => (
                <button key={i} className="filter-chip" onClick={() => onRemove(c)}>
                    {c.label} <Icon name="close" size={9} strokeWidth={2} />
                </button>
            ))}
        </div>
    );
};

const Hero = ({ query, setQuery, activeCount, chips, onRemove, onOpenFilters, searchRef, chapters, activeChapters, onToggleChapter }) => (
    <section className="hero">
        <div className="hero-inner">
            <div className="hero-copy">
                <div className="hero-brand">
                    <img className="hero-brand__logo" src="/img/book-title.png" alt="Legal Operations KPIs" />
                    <span className="hero-brand__rule" aria-hidden="true"></span>
                    <span className="hero-brand__word">Forum</span>
                </div>
                <h1>
                    Legal Operations KPIs, <em>live across the world.</em>
                </h1>
                <p className="hero-lede">
                    One coordinated global program across every chapter. Find the event that fits your role,
                    region, and priorities.
                </p>
            </div>

            <WorldMap chapters={chapters} activeChapters={activeChapters} onToggleChapter={onToggleChapter} />

            <div className="hero-actions">
                <div className="hero-search-row" ref={searchRef}>
                    <label className="search-box">
                        <Icon name="search" size={16} />
                        <input
                            type="search"
                            placeholder="Search events, topics, speakers…"
                            autoComplete="off"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                        />
                    </label>
                    <button className="hero-btn" onClick={onOpenFilters}>
                        <Icon name="filter" size={14} strokeWidth={2} />
                        Filters{activeCount ? ` · ${activeCount}` : ''}
                    </button>
                </div>

                <ActiveFilters chips={chips} onRemove={onRemove} />
            </div>
        </div>
    </section>
);

export default Hero;
